import { colors } from '@noths/polaris-client-ribbons-design-system';
import { fontSize, pxToRem, responsiveFontSize, stack, theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { spacing, fonts, text, designSystemFontSizes } = theme;

export const divider = css`
  margin: ${pxToRem(spacing.xxl)} 0 ${pxToRem(spacing.md)};
  border: none;
  border-bottom: ${pxToRem(1)} solid ${colors.neutralLight};
`;

export const heading = css`
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  ${responsiveFontSize(text.md)};

  margin: ${stack(spacing.lg)};
`;

export const reviewsList = css`
  list-style-type: none;
  padding: 0;
  margin: ${stack(spacing.xxxl)};
`;

export const paginationList = css`
  display: flex;
  list-style: none;
  padding: 0;
`;

export const paginationListItem = css`
  ${fontSize(text.xs.SMALL)};
  font-family: ${fonts.PRIMARY_SEMIBOLD.family};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};
  border-radius: 50%;
  border: none;
  margin-right: ${pxToRem(spacing.xs)};
  height: ${pxToRem(36)};
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${pxToRem(36)};
`;

export const feefoLogo = css`
  display: block;
  width: 120px;
  margin: ${stack(spacing.md)};
`;

export const tooltipWrapper = css`
  ${fontSize(designSystemFontSizes.BODY.XS)}
  margin: ${stack(spacing.xxxl)};
`;

export const tooltipInfo = css`
  cursor: help;
  display: flex;
  align-items: center;
  ${fontSize(designSystemFontSizes.BODY.XS)}
`;

export const tooltipInfoIcon = css`
  display: block;
  height: ${pxToRem(16)};
  width: ${pxToRem(16)};
  margin: 0 0 ${pxToRem(2)} ${pxToRem(4)};
`;

export const noReviews = css`
  margin-bottom: ${pxToRem(40)};
`;
